<template>
  <v-card
    rounded
    color="background"
    style="flex-grow: 1"
    class="d-flex flex-column justify-space-between"
  >
    <v-card-title class="justify-end py-0 pt-3 pr-3" style="position: absolute; right: 0px">
      <v-btn
        v-if="status == 'aberto'"
        fab
        color="primary"
        x-small
        @click.prevent="share"
      >
        <v-icon>mdi-share-variant</v-icon>
      </v-btn>
    </v-card-title>

    <t-event-logo class="d-flex align-center justify-center" style="width: 100%; height: 180px" :event="event" />

    <v-card-text class="d-flex flex-column align-center pb-0 pt-2">
      <span class="text-uppercase">{{ event.competicao }}</span>
      <span class="text-body-1 font-weight-bold mb-1 text-nowrap text-uppercase" v-text="event.nome" />

      <span class="mb-n1 font-weight-bold my-1 text-uppercase d-flex" style="font-size: 1rem">
        <span class="d-flex align-center me-3">
          <v-icon>mdi-calendar-range</v-icon>
          <span>
            {{ luxon.fromFormat(event.inicio, "yyyy-MM-dd HH:mm:ss").toFormat("dd'.'MMMyy").toLocaleUpperCase() }}
          </span>
        </span>
        <span class="d-flex align-center">
          <v-icon>mdi-clock-outline</v-icon>
          <span>
            {{ luxon.fromFormat(event.inicio, "yyyy-MM-dd HH:mm:ss").toFormat("HH'H'mm") }}
          </span>
        </span>
      </span>

      <span class="primary--text mb-n1 mt-3 text-uppercase d-flex align-center" style="font-size: 0.9rem">
        <v-icon style="font-size: 1.2rem">mdi-map-marker-outline</v-icon>
        <span>
          {{ event.nome_local }}
        </span>
      </span>
      <span
        class="text-caption text-uppercase mt-2 mb-0"
        style="font-size: 10px !important; text-align: center !important; width: 25vh; line-height: normal"
        v-text="address"
      />
    </v-card-text>
    <v-card-text class="pa-2">
      <router-link v-if="event.redirect_url === null || event.redirect_url === undefined" :to="link" style="text-decoration: none; width: 100%">
        <v-sheet :color="color" class="heading--text py-2 mt-2" rounded>
          <v-row class="flex-column align-center" no-gutters>
            <span class="py-3 text-uppercase" style="font-size: 18px">
              {{ text }}
            </span>
          </v-row>
        </v-sheet>
      </router-link>
      <a v-else :href="linkRedirect" style="text-decoration: none; width: 100%">
        <v-sheet :color="color" class="heading--text py-2 mt-2" rounded>
          <v-row class="flex-column align-center" no-gutters>
            <span class="py-3 text-uppercase" style="font-size: 18px">
              {{ text }}
            </span>
          </v-row>
        </v-sheet>
      </a>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import { DateTime } from "luxon";
import TEventLogo from "@/components/core/Events/TEventLogo.vue";

import Event from "@/types/Event";

export default Vue.extend({
  name: "TEventCard",

  components: {
    TEventLogo,
  },

  props: {
    event: {
      type: Object as PropType<Event>,
      required: true,
    },
  },

  data() {
    return {
      luxon: DateTime,
    };
  },

  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.xs;
    },
    status(): "aberto" | "futuro" | "encerrado" {
      const now = DateTime.now();
      const start = DateTime.fromFormat(this.event.inicio_venda_online, "y-MM-dd HH:mm:ss");
      const end = DateTime.fromFormat(this.event.termino_venda_online, "y-MM-dd HH:mm:ss");

      if (now < start) {
        return "futuro";
      } else if (now > end) {
        return "encerrado";
      } else {
        return "aberto";
      }
    },
    text(): string {
      return {
        aberto: this.$t("event.buy") as string,
        futuro: "Vendas em Breve",
        encerrado: "Vendas Encerradas",
      }[this.status];
    },
    color(): string {
      return {
        aberto: "green",
        futuro: "orange",
        encerrado: "red",
      }[this.status];
    },
    link(): string {
      return {
        aberto: `/ticket/buy/${this.event.id}`,
        futuro: "/",
        encerrado: "/",
      }[this.status];
    },
    linkRedirect(): string {
      return {
        aberto: this.event.redirect_url,
        futuro: "/",
        encerrado: "/",
      }[this.status];
    },
    address(): string {
      const local = this.event.configuration?.mapping.local;
      if (local) {
        return `${local.cidade} - ${local.estado}`;
      }
      return "";
    },
  },

  methods: {
    share() {
      let url = `${window.location.protocol}//${window.location.hostname}/ticket/buy/${this.event.id}`;

      if (this.event.redirect_url !== null) {
        url = this.event.redirect_url;
      }

      if (this.isMobile) {
        window.navigator.share({
          title: this.event.nome,
          url,
        });
      } else {
        window.navigator.clipboard.writeText(url);
        this.$snackbar("Link copiado para a área de transferência", "success");
      }
    },
  },
});
</script>

<style lang="scss">
.text-nowrap {
  white-space: nowrap;
}
</style>
